
import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="w-full bg-[#111827] h-[329px]">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand Column */}
          <div>
            <h2 className="text-[#10B981] font-bold text-2xl">KOSI</h2>
            <p className="text-[#4B5563] mt-4 text-lg">Understand Your Energy</p>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="text-white font-bold text-base mb-6">Company</h3>
            <ul className="space-y-4">
              <li>
                <Link to="/about" className="text-[#9CA3AF] hover:text-white text-base">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-[#9CA3AF] hover:text-white text-base">
                  How it Works
                </Link>
              </li>
              <li>
                <a 
                  href="mailto:info@get-kosi.com" 
                  className="text-[#9CA3AF] hover:text-white text-base"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Column */}
          <div>
            <h3 className="text-white font-bold text-base mb-6">Legal</h3>
            <ul className="space-y-4">
              <li>
                <Link to="/data-privacy" className="text-[#9CA3AF] hover:text-white text-base">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/data-privacy" className="text-[#9CA3AF] hover:text-white text-base">
                  Data Privacy
                </Link>
              </li>
            </ul>
          </div>

          {/* Follow Us Column */}
          <div>
            <h3 className="text-white font-bold text-base mb-6">Follow Us</h3>
            <div className="flex space-x-4">
              <Link to="#" className="text-[#9CA3AF] hover:text-white">
                <Linkedin size={20} />
              </Link>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-8">
          <p className="text-[#9CA3AF] text-center text-base">
            © 2025 KOSI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
